__turbopack_context__.v({
  "sliderContainer": "ltCUYa_sliderContainer",
});
